import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZES = [50, 100];

// Client-side pagination bar: the caller already fetched the full filtered dataset (`total` items),
// this just controls which slice is shown. Keeps page/pageSize as controlled state on the caller so it
// can reset to page 1 when filters change.
export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange, itemLabel = "data", testId = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-slate-100" data-testid={testId}>
      <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500">
        <span data-testid={`${testId}-summary`}>
          {total === 0 ? `Tidak ada ${itemLabel}` : `Menampilkan ${start}-${end} dari ${total} ${itemLabel}`}
        </span>
        <label className="flex items-center gap-1.5">
          <span>Tampilkan</span>
          <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
            <SelectTrigger className="h-7 w-[70px] text-xs" data-testid={`${testId}-page-size`}><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              {PAGE_SIZES.map((s) => <SelectItem key={s} value={String(s)}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
          <span>/ halaman</span>
        </label>
      </div>
      {/* Phones: the whole row width, tighter buttons, so it stays inside a 375px screen. */}
      <div className="flex w-full sm:w-auto items-center justify-between sm:justify-start gap-1.5 sm:gap-2">
        <Button variant="outline" size="sm" className="h-7 gap-1 px-2 sm:px-3 text-xs" disabled={page <= 1}
          onClick={() => onPageChange(page - 1)} data-testid={`${testId}-prev`}>
          <ChevronLeft size={13} /> Sebelumnya
        </Button>
        <span className="text-xs text-slate-500 whitespace-nowrap" data-testid={`${testId}-indicator`}>
          Halaman {page} dari {totalPages}
        </span>
        <Button variant="outline" size="sm" className="h-7 gap-1 px-2 sm:px-3 text-xs" disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)} data-testid={`${testId}-next`}>
          Selanjutnya <ChevronRight size={13} />
        </Button>
      </div>
    </div>
  );
}
